import axiosInstance from './AxiosInstance';

export function getFeeRates() {
    return axiosInstance.get('ledger/fee-rates');
}

export function createFeeRate(data) {
    return axiosInstance.post('ledger/fee-rates', data);
}
